<template>
  <div class="wrapper">
  <parallax class="section" ></parallax>
    <div class="main main-raised"  style="padding: 50px 0px 30% 0px;">
      <div id = "feedback" class="section section-contacts">
        <div class="container">
          <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
            <h2 class="text-center title h2-size">
              <span class="newline-block">ぶどうIDを</span><span class="newline-block">指定してください</span>
            </h2>
            <form style="margin-top: 30px;" @submit.prevent>
              <md-field class="has-green" md-clearable>
                <label>ぶどうID</label>
                <md-input v-model="grape_id" type="text" required></md-input>
              </md-field>
              <div id="app">
                <md-button class="md-button md-success md-theme-default mgt-1em" @click="checkGrapeId()">移動</md-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-console */
  import axios from "axios"

  export default { 
    data() {
      return {
        grape_id: "",
      }
    },

    methods:{
      checkGrapeId:function(){
        var vm = this;
        if(vm.grape_id.length !=0)
          this.$router.push(vm.grape_id);
      },
    }
  }
</script>